<template>
  <div
      v-loading="loading"
      class="permissions-page"
      style="margin: 90px;">
    <el-header style="height: 100px;  margin-top: 20px;">
      <span
          class="ring-card__header-buttons"
          style="margin: 0px 0px 20px 0px; float: right;">
        <RefreshButton @click.native="refresh(true)" />
      </span>
      <div style="text-align: center; color: #1998d5">
        <h2>Manage Permissions</h2>
      </div>
    </el-header>
    <div style="height: 50px;">
      <el-tooltip content="Create Permission">
        <el-button
            size="medium"
            type="primary"
            plain
            style="float: right;font-size: 14px;"
            @click="openNewPermissionDialog()">
          <i class="el-icon-plus"></i>
          Create
        </el-button>
      </el-tooltip>
      <el-input
          v-model="filter"
          placeholder="Find by Resource or Action"
          clearable
          style="font-size: 14px; margin: 0px 10px 20px 0px; float: right; width: 300px;"
          type="text">
        <i
            slot="prefix"
            class="el-input__icon el-icon-search" />
      </el-input>
    </div>
    <el-card
        v-for="permission in filteredPermissionList"
        :key="permission.index"
        :index="permission.id"
        shadow="hover"
        style="width:100%">
      <div class="card-footer">
        <el-collapse style="border: none">
          <h3>{{ permission.resource }}</h3>
          <el-collapse-item>
            <template slot="title">
              <span
                  style="font-size: 18px;
                  margin-top: -40px;
                  color: grey;">{{ permission.action }}</span>
            </template>
            <permission-details
                :permission="permission"
                @reload="loadPermissions" />
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="true">
      <span style="margin-left: 40px">
        <img
            :src="icons.warning"
            class="icon">
      </span>
      <span class="dialog_title_style">
        Delete this permission?
      </span>
      <div style="padding: 30px">
        <div class="dialog_item_style">
          <span style="margin-right: 20px">Resource:</span><b>{{ dialogResource }}</b>
        </div>
        <div class="dialog_item_style">
          <span style="margin-right: 40px">Action:</span><b>{{ dialogAction }} </b>
        </div>
      </div>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            @click="deletePermission(dialogPermissionId);">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :visible.sync="dialogCreatePermissionVisible"
        width="30%"
        :show-close="true">
      <div class="dialog_title_style">
        Create permission
      </div>
      <form
          :model="createForm"
          :disabled="!createForm.resource"
          class="dialog_create_form_style"
          @submit.prevent="createPermission( createForm.resource, createForm.action)">
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Resource:
          </div>
          <el-input
              v-model="createForm.resource"
              required
              placeholder="Permission Name"
              input="string"
              style="max-width: 400px;" />
        </div>
        <div class="dialog_create_item_style">
          <div class="dialog_create_item_title_style">
            Action:
          </div>
          <el-input
              v-model="createForm.action"
              required
              placeholder="Action"
              input="string"
              style="max-width: 400px;" />
        </div>
      </form>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="dialogCreatePermissionVisible = false">Cancel</el-button>
        <el-button
            type="primary"
            :disabled="!createForm.resource || !createForm.action"
            @click="createPermission( createForm.resource, createForm.action)">Create</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import RefreshButton from "@/containers/Customer/RefreshButton";
import { createNamespacedHelpers as h } from "vuex";
import Permission from "../../mixins/permission";
import PermissionDetails from "./PermissionDetails.vue";
import axios from "axios";
const { mapGetters: sharedGetters, mapActions: sharedActions } = h("shared");

export default {
  name: "PermissionsManager",
  components: {
    PermissionDetails,
    Permission,
    RefreshButton,
  },
  data() {
    return {
      filter: "",
      permissionsList: [],
      loading: false,
      dialogVisible: false,
      dialogResource: "",
      dialogAction: "",
      dialogPermissionId: "",
      createForm: { resource: null, action: null },
      dialogCreatePermissionVisible: false,
      icons: {
        warning: require("@/assets/icons/new-ui/customer/authorizations/shared/warning.svg"),
      },
    };
  },
  computed: {
    permission() {
      return permission;
    },
    ...sharedGetters(["permissions", "roles"]),
    filteredPermissionList() {
      return this.permissionsList.filter((p) => {
        const filter = this.filter.toUpperCase();
        const hasResourceMatch = p.resource.toUpperCase().includes(filter);
        const hasActionMatch = p.action.toUpperCase().includes(filter);
        return hasResourceMatch || hasActionMatch;
      });
    },
  },
  created() {
    this.isAdmin();
    this.loadPermissions();
    this.permissionsList = this.permissions.entries.map((item) => {
      return item;
    });
  },
  methods: {
    ...sharedActions(["fetchPermissions"]),

    goBack() {
      this.$router.go(-1);
    },
    refresh() {
      this.loadPermissions();
    },
    loadPermissions() {
      this.loading = true;
      this.fetchPermissions()
        .then((_) => {
          this.permissionsList = this.permissions.entries.map((item) => {
            return item;
          });
        })
        .catch((_) => {
          this.$message.warning({
            title: "Permissions",
            message: "Couldn't be loaded. Reload the page.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isAdmin: function () {
      if (!this.$store.getters["auth/isAdmin"]) {
        this.$router.back();
      }
    },
    deletePermission(id) {
      axios
        .delete(`/v3/permissions/${id}`, {})
        .then((response) => {
          this.$message({
            title: "Success",
            message: `Permission Deleted`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message: "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => {
          this.dialogVisible = false;
          this.loadPermissions();
        });
    },
    openRemovePermissionDialog(p) {
      this.dialogVisible = true;
      this.dialogAction = p.action;
      this.dialogResource = p.resource;
      this.dialogPermissionId = p.id;
    },
    openNewPermissionDialog() {
      this.dialogCreatePermissionVisible = true;
    },
    createPermission(resource, action) {
      let payload = {
        permission: {
          resource: resource,
          action: action,
          enabled: true,
          roles_flag: [
            { role: "user", authorized: false },
            { role: "user_plus", authorized: false },
            { role: "lead", authorized: false },
          ],
        },
      };
      axios
        .post(`/v3/permissions`, payload)
        .then((response) => {
          this.$message({
            title: "Success",
            message: `Permission Created`,
            type: "success",
          });
        })
        .catch((error) => {
          this.$message({
            title: "Error",
            message: "Something went wrong! Try again.",
            type: "error",
          });
        })
        .finally(() => {
          this.createForm = { resource: null, action: null };
          this.dialogCreatePermissionVisible = false;
          this.loadPermissions();
        });
    },
  },
};
</script>
<style lang="scss">
.permissions-page {
  margin: 0px !important;
  padding: 0px 50px;
  background: #fff;
}
.el-table::before {
  width: 0% !important;
}
.dialog_title_style {
  font-size: 24px;
  position: absolute;
  margin-left: 25px;
  margin-bottom: 5px;
  font-weight: 500;
  line-height: 36px;
}
.dialog_item_style {
  font-size: 16px;
  position: inherit;
  margin-left: 12px;
  margin-top: 5px;
  font-weight: 500;
  line-height: 36px;
}
.dialog_create_item_style {
  font-size: 16px;
  position: inherit;
  margin: 20px 0px 0px 20px;
  font-weight: 500;
}
.dialog_create_item_title_style {
  padding-bottom: 2%;
}
.dialog_create_form_style {
  margin: 65px 0px 0px 20px;
}
</style>
